// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.css";
	// return url for filenames based on template
	return "" + ({"1535":"average-head","1822":"SimpleCaptureVideo","4970":"ReactJson","9179":"FrameAdvisorVideo","9190":"MirrorAsyncRoot","9267":"VtoCaptureVideo","9827":"MirrorContainer"}[chunkId] || chunkId) + ".chunk.css";
};